import tonysFinefooodsLogo from "/img/integration/tonysfinefoods.png"
import { ConnectLogo } from "../connect-logo"
import { Form } from "@/components/form/Form.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { Input, PasswordInput } from "@/components/form/Input.tsx"
import { Button } from "@/components/ui/button.tsx"
import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { use_connect_redirect_to } from "../use_connect_redirect_to"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { updateIntegration, upsertIntegration } from "@/api/integration"
import { normalize_portal_url } from "../portal_url"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectTonysFinefooodsPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)
  const [, setLocation] = useLocation()
  const [loading, setLoading] = useState(false)

  const form = useFormState({
    portal_url: "",
    username: "",
    password: "",
  })

  async function onSubmit() {
    setLoading(true)
    form.set_form_errors([])
    const res = await upsertIntegration("tonysfinefoods", form.username.value, { password: form.password.value })
    setLoading(false)
    if (!res.ok) {
      form.set_form_errors(["Tony's Fine Foods login failed. Please try again."])
      return
    }
    let int = res.value.data
    if (form.portal_url.value.trim()) {
      const metaRes = await updateIntegration(int.id, {
        data: { portal_url: normalize_portal_url(form.portal_url.value) },
      })
      if (!metaRes.ok) {
        form.set_form_errors(["Connection created but failed to save portal URL. Please try again."])
        return
      }
    }
    setLocation(redirectTo)
  }

  return (
    <CenterColumnContainer>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <ConnectLogo src={tonysFinefooodsLogo} alt="Tony's Fine Foods" />
        <p class="text-gray-500 text-sm">Enter your Tony's Fine Foods portal credentials to sync your deduction data.</p>
        <Input label="Portal URL" type="text" name="portal_url" placeholder="https://portal.tonysfinefoods.com" bind={form.portal_url} noAutofill />
        <Input label="Username" type="text" name="username" required={true} bind={form.username} noAutofill />
        <PasswordInput label="Password" required={true} bind={form.password} noAutofill />
        <div class="flex justify-end">
          <Button
            type="submit"
            class="bg-gray-900 text-white rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
            disabled={loading}>
            {loading ? "Connecting..." : "Connect Account"}
          </Button>
        </div>
      </Form>
    </CenterColumnContainer>
  )
}
